import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { path } from "../../../utils/common/constant";
import { withTranslation } from "react-i18next";
import { projects } from "../../../models/mockdata";
import { getprojects } from "../../../services/projects";
import { encryptString } from "../../../utils/common/hashData";
const ActivitySection = (props) => {
  const [ProjectsData, setProjectsData] = useState([]);
  const [IsloadingData, setIsloadingData] = useState(false);
  const pagesize = 6;
  const [totalPages, setTotalPages] = useState(1);

  const [currentPage, setCurrentPage] = useState(1);
  const getAllProject = async () => {
    try {
      const res = await getprojects(currentPage, pagesize);
      const validBlogs = res.data.filter(
        (item) => item.content && item.name && item.thumbnail
      ); // Lọc các mục hợp lệ
      setProjectsData(validBlogs); // Cập nhật state với dữ liệu hợp lệ
      setIsloadingData(false); // Tắt trạng thái loading
    } catch (err) {
      console.error(err.message);
      setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
    }
  };
  useEffect(() => {
    getAllProject();
  }, []);

  const { t } = props;
  const [centerIndex, setCenterIndex] = useState(0);

  const navigate = useNavigate();
  const PrevArrow = (props) => {
    const { style, onClick } = props;
    return (
      <div
        className="absolute top-[-90px]  right-72 pv:max-ph:right-[20%] ph:max-md:right-[15%] pv:max-md:top-[-60px] transform z-0 border-[2px]  border-primary_light hover:opacity-60 duration-300 rounded-lg cursor-pointer p-2"
        onClick={onClick}
      >
        <Icon
          icon={"mingcute:arrow-left-line"}
          className="h-8 w-8 text-primary qhd:h-12 qhd:w-12"
        ></Icon>
      </div>
    );
  };

  const NextArrow = (props) => {
    const { style, onClick } = props;
    return (
      <div
        className="absolute top-[-90px]  ph:max-md:right-[0] pv:max-ph:right-[0%] pv:max-md:top-[-60px]  right-52 transform z-0 border-[2px] border-primary_light hover:opacity-60 duration-300 rounded-lg cursor-pointer p-2"
        onClick={onClick}
      >
        <Icon
          icon={"mingcute:arrow-right-line"}
          className="h-8 w-8  text-primary  qhd:h-12 qhd:w-12"
        ></Icon>
      </div>
    );
  };

  const settings = {
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 3,
    infinite: true,
    afterChange: (current) => setCenterIndex(current),
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    appendDots: (dots) => (
      <div style={{ bottom: "-20px", position: "relative" }}>
        <ul className="flex justify-center space-x-4">{dots}</ul>
      </div>
    ),
    customPaging: (i) => (
      <div className="w-2 h-2 rounded-full bg-gray-400 hover:bg-secondary1 transition-colors cursor-pointer"></div>
    ),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1200, // Màn hình lớn (Laptop)
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992, // Màn hình vừa (Tablet)
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 768, // Màn hình nhỏ (Mobile lớn)
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
      {
        breakpoint: 576, // Màn hình rất nhỏ (Mobile nhỏ)
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
    ],
  };

  return (
    <div className=" w-[100%] py-10 relative ">
      <div className=" max-w-[1140px] pvmax:max-dv:w-[85%]  mx-auto flex justify-between pt-10 pb-10 pv:max-md:pb-20">
        <div className="flex flex-col  text-primary">
          <p
            className="text-[1.5rem] ph:text-[2.5rem] qhd:text-[2.5rem] "
            style={{ lineHeight: 1.25, fontWeight: 500 }}
          >
            {t("HomeActivitySubtitle")}
          </p>
        </div>

        <button
          className="inline-flex px-[42px]  items-center justify-center gap-2 bg-secondary1 hover:bg-opacity-60 text-white   rounded-[10px] transition-colors"
          onClick={() => navigate("../" + path.common.ACTIVITY)}
        >
          <div className="h-[50px]  flex justify-center items-center ">
            <p
              className="text-[1rem] qhd:text-[1rem]"
              style={{ fontWeight: 500 }}
            >
              <p className="">{t("HomeActivityviewall")}</p>
            </p>
          </div>
        </button>
      </div>
      <Slider
        {...settings}
        className=" max-w-[1240px] pv:max-lg:w-[85%] lg:w-[95%]   mx-auto"
      >
        {ProjectsData.slice(0, 4).map((slide, index) => (
          <div
            key={index}
            className={`transition-transform duration-500 cursor-pointer group overflow-hidden  ${
              index === centerIndex ? "scale-100 z-0 " : "scale-75"
            }`}
            onClick={() => {
              console.log(
                encryptString({
                  str: slide?.id.toString(),
                  secretKey: process.env.PRIVATE_KEY,
                })
              );
              navigate(
                "../" +
                  path.common.ACTIVITIY_DETAIL.replace(
                    ":id",
                    encryptString({
                      str: slide?.id.toString(),
                      secretKey: process.env.PRIVATE_KEY,
                    })
                  ),
                {
                  state: {
                    id: encryptString({
                      str: slide?.id.toString(),
                      secretKey: process.env.PRIVATE_KEY,
                    }),
                  },
                }
              );
            }}
          >
            <div className="relative w-full  h-[300px] ph:max-md:h-[400px] overflow-hidden shadow-xl">
              <img
                src={slide.thumbnail}
                alt={slide.name}
                className="w-full h-[300px] ph:max-md:h-[400px]  object-cover transition-all duration-500"
              />
              <div className="absolute bottom-0 bg-black/60 group-hover:bg-secondary1  left-0 w-full text-white text-center py-4">
                <h3 className="text-lg line-clamp-1">{slide.name}</h3>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default withTranslation()(ActivitySection);
